import { useAppDispatch, useAppSelector } from '../../store/hooks'
import { logout, selectAccountId, selectAuthenticatedUserToken } from '../../store/auth/authSlice'
import { crossAccountLogin, refreshToken } from '../../store/auth/authActions'
import { useLocation, useNavigate } from 'react-router-dom'
import { refreshLock } from '../../common/baseQuery'
import { readToken, Token } from '../../common/token'

export const useAccountSwitch = () => {
  const accountId = useAppSelector(selectAccountId)
  const navigate = useNavigate()
  const location = useLocation()
  const dispatch = useAppDispatch()
  const serializedToken = useAppSelector(selectAuthenticatedUserToken)

  const switchToAccount = async (targetAccountId: string) => {
    if (serializedToken) {
      const token = Token.fromSerialized(serializedToken)
      if (token.isAccessTokenExpired) {
        if (token.isRenewable) {
          refreshLock(() => {
            dispatch(refreshToken({ accountId: token.accountId, refreshToken: token.refreshToken! }))
          }).catch(console.error)
        } else {
          dispatch(logout(location))
          window.location.href = '/'
        }
      }
    } else {
      const token = readToken()
      if (token) {
        refreshLock(() => {
          dispatch(refreshToken({ accountId: token.accountId, refreshToken: token.refreshToken! }))
        }).catch(console.error)
      }
    }

    const freshToken = readToken()
    if (freshToken && accountId !== targetAccountId) {
      const result = await dispatch(
        crossAccountLogin({
          targetAccountId,
          token: freshToken.accessToken,
        }),
      )
      if (result.meta && result.meta.requestStatus === 'fulfilled') {
        navigate('/')
        window.location.reload()
      }
      return result
    }
    return Promise.resolve({ error: 'No token available or already on the target account' })
  }

  return { switchToAccount, currentAccountId: accountId }
}
